import {
  CreateFeatureSagaPayloadType,
  DeleteFeatureSagaPayloadType,
  UpdateFeatureSagaPayloadType,
} from "../../slices/feature-management/Types";

export const featureManagementSagaActionTypes = {
  callGetFeaturesSaga: "callGetFeaturesSaga",
  callGetFeatureTechnologyOptionsSaga: "callGetFeatureTechnologyOptionsSaga",
  callCreateFeatureSaga: "callCreateFeatureSaga",
  callUpdateFeatureSaga: "callUpdateFeatureSaga",
  callDeleteFeatureSaga: "callDeleteFeatureSaga",
};

export const getFeaturesSagaAction: () => {
  type: string;
} = () => {
  return {
    type: featureManagementSagaActionTypes.callGetFeaturesSaga,
  };
};

export const getFeatureTechnologyOptionsSagaAction: () => {
  type: string;
} = () => {
  return {
    type: featureManagementSagaActionTypes.callGetFeatureTechnologyOptionsSaga,
  };
};

export const createFeatureSagaAction: (payload: CreateFeatureSagaPayloadType) => {
  type: string;
  payload: CreateFeatureSagaPayloadType;
} = (payload: CreateFeatureSagaPayloadType) => {
  return {
    type: featureManagementSagaActionTypes.callCreateFeatureSaga,
    payload,
  };
};

export const deleteFeatureSagaAction: (payload: DeleteFeatureSagaPayloadType) => {
  type: string;
  payload: DeleteFeatureSagaPayloadType;
} = (payload: DeleteFeatureSagaPayloadType) => {
  return {
    type: featureManagementSagaActionTypes.callDeleteFeatureSaga,
    payload,
  };
};

export const updateFeatureSagaAction: (payload: UpdateFeatureSagaPayloadType) => {
  type: string;
  payload: UpdateFeatureSagaPayloadType;
} = (payload: UpdateFeatureSagaPayloadType) => {
  return {
    type: featureManagementSagaActionTypes.callUpdateFeatureSaga,
    payload,
  };
};
